/* Previously viewed badge
   Records products the visitor opens (product pages) in localStorage and
   adds a "Previously viewed" badge to matching product cards site-wide. */
(function () {
  var STORAGE_KEY = 'nyc-previously-viewed-products';
  var MAX_ITEMS = 100;
  var BADGE_LABEL = 'Viewed';

  function getViewed() {
    try {
      var list = JSON.parse(window.localStorage.getItem(STORAGE_KEY) || '[]');
      return Array.isArray(list) ? list : [];
    } catch (e) {
      return [];
    }
  }

  function recordView(productId) {
    productId = String(productId);
    try {
      var list = getViewed().filter(function (id) {
        return id !== productId;
      });
      list.unshift(productId);
      window.localStorage.setItem(STORAGE_KEY, JSON.stringify(list.slice(0, MAX_ITEMS)));
    } catch (e) {
      /* localStorage unavailable (private mode, blocked cookies) — feature is a no-op */
    }
  }

  function applyBadges() {
    var viewed = getViewed();
    if (!viewed.length) return;

    var cards = document.querySelectorAll('[data-pv-product-id]:not([data-pv-processed])');

    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      var id = card.getAttribute('data-pv-product-id');
      card.setAttribute('data-pv-processed', 'true');

      if (!id || viewed.indexOf(id) === -1) continue;
      if (card.querySelector('.product-badge--previously-viewed')) continue;

      var container = card.querySelector('.product-badges');
      if (!container) continue;

      var badge = document.createElement('div');
      badge.className = 'product-badge product-badge--previously-viewed';
      badge.textContent = BADGE_LABEL;
      container.appendChild(badge);
    }
  }

  var currentProductId = document.currentScript
    ? document.currentScript.getAttribute('data-current-product-id')
    : '';

  function init() {
    if (currentProductId) recordView(currentProductId);
    applyBadges();

    /* Re-apply for cards added later (AJAX filtering, pagination, carousels) */
    new MutationObserver(applyBadges).observe(document.body, {
      childList: true,
      subtree: true
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
